import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi2";
import { NiggleLog } from "../../types/post";
import {
  useLogCardActions,
  LogCardActionsProps,
} from "../../hooks/useLogCardActions";
import LogCard from "../shared/LogCard";
import {
  LogCardMetric,
  LogCardMetricsRow,
  LogCardNote,
} from "../shared/LogCardContent";

interface NiggleLogCardProps extends LogCardActionsProps<
  NiggleLog & { id: string }
> {
  log: NiggleLog & { id: string };
}

const NiggleLogCard: React.FC<NiggleLogCardProps> = ({
  log,
  onDelete,
  onEdit,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { handleDelete, handleEdit } = useLogCardActions(log, {
    onDelete,
    onEdit,
  });

  const handleCardClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div onClick={handleCardClick} className="cursor-pointer">
      <LogCard
        className={isExpanded ? "bg-base-100" : "bg-amber-500/10"}
        onDelete={onDelete ? handleDelete : undefined}
        onEdit={onEdit ? handleEdit : undefined}
      >
        {/* Header */}
        <div className="flex items-center gap-2 pr-8">
          <span className="text-[11px] font-medium tracking-wide uppercase text-base-content/70 font-geist">
            Niggle
          </span>
          <HiChevronDown
            className={`w-3 h-3 text-base-content/30 transition-transform duration-200 ml-auto ${
              isExpanded ? "rotate-180" : ""
            }`}
          />
        </div>

        {/* Expanded details */}
        {isExpanded && (
          <div className="mt-2 flex flex-col gap-2">
            <LogCardMetricsRow>
              <LogCardMetric value={log.pain} label="Pain" />
              <LogCardMetric value={log.impact} label="Impact" />
            </LogCardMetricsRow>
            {log.notes && <LogCardNote text={log.notes} />}
          </div>
        )}
      </LogCard>
    </div>
  );
};

export default NiggleLogCard;
